import React from 'react';

const Footer = () => {
  return (
    <footer
      style={{
        position: 'absolute',
        bottom: '0',
        width: '100%',
        textAlign: 'center',
        padding: '10px 0',
        backgroundColor: 'rgba(0, 0, 0, 0.9)', // Subtle dark background
        color: '#b3b3b3', // Light grey for professional look
        fontFamily: "'Poppins', sans-serif",
        fontSize: '12px',
        zIndex: 1000,
        borderTop: '1px solid rgba(255, 255, 255, 0.1)', // Add subtle separator
      }}
    >
      © {new Date().getFullYear()} DeepNode. All rights reserved. | Made with{' '}
      <span style={{ color: '#ff5757' }}>❤️‍🔥</span> 
    </footer>
  );
};

export default Footer;
